export default __webpack_public_path__ + "static/media/panelBlack.9fcabe02.mp4";